<template>
  <div>
    <a v-if="isHyperlinkActive === true" class="whitespace-nowrap text-primary" :href="`tel:${modelValue}`">{{ labelNationalFormat }}</a>
    <div v-else class="whitespace-nowrap">{{ labelNationalFormat }}</div>
  </div>
</template>

<script>
import { PhoneNumberUtil, PhoneNumberFormat } from "google-libphonenumber";
const phoneUtil = PhoneNumberUtil.getInstance();
const textFormatter = PhoneNumberFormat;

export default {
  name: "BasePhoneNumberField",
  props: {
    modelValue: String,
    isHyperlinkActive: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    labelRegionCode() {
      return this.modelValue ? phoneUtil.getRegionCodeForNumber(phoneUtil.parseAndKeepRawInput(this.modelValue)) : "US";
    },
    parsedlabelPhoneNumber() {
      return this.modelValue ? phoneUtil.parseAndKeepRawInput(this.modelValue, this.labelRegionCode) : null;
    },
    labelNationalFormat() {
      return this.modelValue ? phoneUtil.format(this.parsedlabelPhoneNumber, textFormatter.NATIONAL) : "";
    },
  },
};
</script>
